import React from 'react';
import { JobDefinitionContextProvider } from 'modals/job-definition/context/JobDefinitionContext';
import { RunJobDefinitionModal } from 'modals/job-definition/RunJobDefinitionModal';

export const RunJobDefinition = () => {
  return (
    <JobDefinitionContextProvider>
      <RunJobDefinitionModal />
    </JobDefinitionContextProvider>
  );
};
